module.exports = __webpack_public_path__ + "static/media/planlosningPicto.14146528.png";